import { ACL_TYPE } from '@openx/types/aclType.ts';
import { usePermissionContext } from '@openx/utils/permission/context/PermissionContext.tsx';
import { isAllowedByCompiledAcl } from '@openx/utils/permission/validators.ts';
import { useMemo } from 'react';

export const useShowLal = (): boolean => {
  const { useIsAllowed } = usePermissionContext();
  const { isAllowed } = useIsAllowed();

  return useMemo(() => isAllowed(isAllowedByCompiledAcl(ACL_TYPE.LOOKALIKE_SEGMENTS_ENABLED)), [isAllowed]);
};
